<template>
  <div class="offset-15">
    <div class="col-xl-12 col-lg-12 col-md-12 mb-4">
      <div class="fade-in" id="alertError" ref="alert"></div>
      <div class="card card-style">
        <form
          action
          @submit.prevent="saveEditInformation"
          id="formInfo"
          data-vs-form="form-info"
        >
          <div class="card-body">
            <div>
              <div class="title_edit_container">
                <div class="subtitle_useram">
                  {{ $t('message.ei_titleList_text_6') }}
                </div>
                <transition name="fade" mode="out-in">
                  <div v-if="isEditingInfo" class="m-portlet__head-caption">
                    <button
                      @click.prevent="cancelEditInformation('isEditingInfo')"
                      data-vs-button="cancel-edit-info"
                      class="btn btn-secondary mr-4"
                    >
                      {{ $t('message.ob_submit_swal_reject') }}
                    </button>
                    <button
                      v-if="!loadingInfo"
                      type="submit"
                      class="btn btn-primary"
                      data-vs-button="save-edit-info"
                      :disabled="errors.any()"
                    >
                      {{ $t('message.ei_personal_info_save_changes') }}
                    </button>
                    <button
                      v-if="loadingInfo"
                      class="btn btn-primary"
                      data-vs-button="save-edit-info-loading"
                      :disabled="errors.any()"
                    >
                      <div class="m-loader m-loader--light"></div>
                    </button>
                  </div>
                </transition>
              </div>
              <hr />
            </div>
            <div class="m-form__group row form-margin-fix">
              <div class="col-12 input-label-container">
                <div class="col-6 group-inputs-label">
                  <input
                    data-vs-input="form-info-user"
                    @keypress="editInformation('isEditingInfo', 'usuario')"
                    @keyup.delete="editInformation('isEditingInfo', 'usuario')"
                    class="input_styles"
                    :class="[
                      employeeState !== 3 ? 'groupInputLabel__input--borderBottom' : '',
                    ]"
                    type="text"
                    id="formInfo.usuario"
                    v-validate="'required'"
                    name="formInfo.usuario"
                    v-model="formInfo.usuario"
                    :required="userTexting"
                    :disabled="employeeState == 3"
                  />
                  <div v-show="employeeState !== 3" class="edit--element">
                    <zt-icon name="pen" />
                  </div>
                  <span class="highlight"></span>
                  <span class="bar"></span>
                  <label class="label_styles">
                    {{ $t('message.userActive.usuario') }}
                    <span v-if="formInfoRequires.usuario.required" class="required_style"
                      >*</span
                    >
                  </label>
                  <div class="m--font-danger" v-show="errors.has('formInfo.usuario')">
                    <p class="error-style">
                      {{ $t('message.login_first_login_required_field') }}
                    </p>
                  </div>
                  <div class="m--font-warning" v-show="alertWarningShow">
                    <p class="warning-style">
                      <b>{{ $t('message.actions.atention') }}: </b
                      >{{ $t('message.userActive.error_username_change') }}
                    </p>
                  </div>
                </div>
                <div class="col-6 group-inputs-label">
                  <input
                    data-vs-input="form-info-email"
                    @keypress="editInformation('isEditingInfo')"
                    @keyup.delete="editInformation('isEditingInfo')"
                    @paste="editInformation('isEditingInfo')"
                    class="input_styles"
                    :class="[
                      employeeState !== 3 ? 'groupInputLabel__input--borderBottom' : '',
                    ]"
                    type="text"
                    id="formInfo.mail"
                    v-validate="'email'"
                    name="mail"
                    v-model="formInfo.mail"
                    :required="emailTexting"
                    placeholder=" "
                    :disabled="employeeState == 3"
                  />
                  <div v-show="employeeState !== 3" class="edit--element">
                    <zt-icon name="pen" />
                  </div>
                  <span class="highlight"></span>
                  <span class="bar"></span>
                  <label class="label_styles">
                    {{ $t('message.userActive.mail') }}
                    <span v-if="formInfoRequires.mail.required" class="required_style"
                      >*</span
                    >
                  </label>
                  <div class="m--font-danger" v-show="errors.has('mail')">
                    <p
                      class="error-style"
                      v-for="error in errors.collect('mail')"
                      v-bind:key="error"
                    >
                      {{ error }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-12 input-label-container">
                <div class="col-6 group-inputs-label">
                  <input
                    data-vs-input="form-info-name"
                    @keypress="editInformation('isEditingInfo')"
                    @keyup.delete="editInformation('isEditingInfo')"
                    class="input_styles"
                    :class="[
                      employeeState !== 3 ? 'groupInputLabel__input--borderBottom' : '',
                    ]"
                    type="text"
                    id="formInfo.nombre"
                    v-validate="'required'"
                    name="formInfo.nombre"
                    v-model="formInfo.nombre"
                    :required="nameTexting"
                    :disabled="employeeState == 3"
                  />
                  <div v-show="employeeState !== 3" class="edit--element">
                    <zt-icon name="pen" />
                  </div>
                  <span class="highlight"></span>
                  <span class="bar"></span>
                  <label class="label_styles">
                    {{ $t('message.userActive.nombre') }}
                    <span v-if="formInfoRequires.nombre.required" class="required_style"
                      >*</span
                    >
                  </label>
                  <div class="m--font-danger" v-show="errors.has('formInfo.nombre')">
                    <p class="error-style">
                      {{ $t('message.login_first_login_required_field') }}
                    </p>
                  </div>
                </div>
                <div class="col-6 group-inputs-label">
                  <input
                    data-vs-input="form-info-lastname"
                    @keypress="editInformation('isEditingInfo')"
                    @keyup.delete="editInformation('isEditingInfo')"
                    class="input_styles"
                    :class="[
                      employeeState !== 3 ? 'groupInputLabel__input--borderBottom' : '',
                    ]"
                    type="text"
                    id="formInfo.apellido"
                    v-model="formInfo.apellido"
                    v-validate="'required'"
                    name="formInfo.apellido"
                    :required="lastnameTexting"
                    :disabled="employeeState == 3"
                  />
                  <div v-show="employeeState !== 3" class="edit--element">
                    <zt-icon name="pen" />
                  </div>
                  <span class="highlight"></span>
                  <span class="bar"></span>
                  <label class="label_styles">
                    {{ $t('message.userActive.apellido') }}
                    <span v-if="formInfoRequires.apellido.required" class="required_style"
                      >*</span
                    >
                  </label>
                  <div class="m--font-danger" v-show="errors.has('formInfo.apellido')">
                    <p class="error-style">
                      {{ $t('message.login_first_login_required_field') }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-12 input-label-container">
                <div v-if="country === 'AR' || country === 'LA'" class="col-6 group-inputs-label">
                  <input
                    data-vs-input="form-info-dni"
                    @keypress="editInformation('isEditingInfo')"
                    @keyup.delete="editInformation('isEditingInfo')"
                    class="input_styles"
                    :class="[
                      employeeState !== 3 ? 'groupInputLabel__input--borderBottom' : '',
                    ]"
                    type="text"
                    id="formInfo.dni"
                    v-validate="'required'"
                    v-model="formInfo.dni"
                    name="formInfo.dni"
                    :required="docTexting"
                    :disabled="employeeState == 3"
                  />
                  <div v-show="employeeState !== 3" class="edit--element">
                    <zt-icon name="pen" />
                  </div>
                  <span class="highlight"></span>
                  <span class="bar"></span>
                  <label class="label_styles">
                    {{ $t('message.userActive.dni') }}
                    <span v-if="formInfoRequires.dni.required" class="required_style"
                      >*</span
                    >
                  </label>
                  <div class="m--font-danger" v-show="errors.has('formInfo.dni')">
                    <p class="error-style">
                      {{ $t('message.login_first_login_required_field') }}
                    </p>
                  </div>
                </div>
                <div class="col-6 group-inputs-label">
                  <input
                    data-vs-input="form-info-cuil"
                    @keypress="editInformation('isEditingInfo', 'cuil')"
                    @keyup.delete="editInformation('isEditingInfo', 'cuil')"
                    class="input_styles"
                    :class="[
                      employeeState !== 3 ? 'groupInputLabel__input--borderBottom' : '',
                    ]"
                    type="text"
                    id="formInfo.cuil"
                    v-validate="'required|no_hyphen'"
                    v-model="formInfo.cuil"
                    name="formInfo.cuil"
                    :required="cuilTexting"
                    :disabled="employeeState == 3"
                  />
                  <div v-show="employeeState !== 3" class="edit--element">
                    <zt-icon name="pen" />
                  </div>
                  <span class="highlight"></span>
                  <span class="bar"></span>
                  <label class="label_styles">
                    <span v-if="country === 'BO' || country === 'PY'">
                      {{ $t('message.userActive.dni') }}
                    </span>
                    <span v-else>
                      {{ $t('message.userActive.cuil') }}
                    </span>
                    <span v-if="formInfoRequires.cuil.required" class="required_style"
                      >*</span
                    >
                  </label>
                  <div class="m--font-danger" v-show="errors.has('formInfo.cuil')">
                    <p class="error-style">
                      {{ $t('message.login_first_login_required_field') }}
                    </p>
                  </div>
                </div>
                <div class="col-6 group-inputs-label">
                  <datepicker
                    data-vs-datepicker="form-info-birthdate"
                    @click="editInformation('isEditingInfo')"
                    @input="editInformation('isEditingInfo')"
                    @cleared="
                      ;(formInfo.fecha_nacimiento = ''),
                        (formInfo.fecha_nacimiento_format = '')
                    "
                    :language="es"
                    :bootstrap-styling="true"
                    name="formInfo.fecha_nacimiento"
                    id="formInfo.fecha_nacimiento"
                    format="dd/MM/yyyy"
                    :clear-button="employeeState != 3"
                    clear-button-icon="fa fa-times"
                    v-model="formInfo.fecha_nacimiento"
                    input-class="input-datepicker"
                    :disabled="employeeState == 3"
                  ></datepicker>
                  <div
                    v-show="employeeState !== 3"
                    class="edit--element calendar-element"
                  >
                    <zt-icon name="calendar" />
                  </div>
                  <label
                    class="label_styles_date"
                    :class="[bornDateTexting ? 'elevateLabel' : '']"
                  >
                    {{ $t('message.userActive.fecha_nacimiento') }}
                    <span
                      v-if="formInfoRequires.fecha_nacimiento.required"
                      class="required_style"
                      >*</span
                    >
                  </label>
                </div>
                <div class="col-6 group-inputs-label" id="fechaContratacion">
                  <!-- {{formInfo.fecha_contratacion}} -->
                  <datepicker
                    data-vs-datepicker="form-info-hiring"
                    @click="editInformation('isEditingInfo')"
                    @input="editInformation('isEditingInfo')"
                    @cleared="
                      ;(formInfo.fecha_contratacion = ''),
                        (formInfo.fecha_contratacion_format = '')
                    "
                    :language="es"
                    name="formInfo.fecha_contratacion"
                    id="formInfo.fecha_contratacion"
                    format="dd/MM/yyyy"
                    :bootstrap-styling="true"
                    clear-button-icon="fa fa-times"
                    :clear-button="employeeState != 3"
                    v-model="formInfo.fecha_contratacion"
                    input-class="input-datepicker"
                    :disabled="employeeState == 3"
                  ></datepicker>
                  <div
                    v-show="employeeState !== 3"
                    class="edit--element calendar-element"
                  >
                    <zt-icon name="calendar" />
                  </div>
                  <label
                    class="label_styles_date"
                    :class="[startDateTexting ? 'elevateLabel' : '']"
                  >
                    {{ $t('message.userActive.fecha_contratacion') }}
                    <span
                      v-if="formInfoRequires.fecha_contratacion.required"
                      class="required_style"
                      >*</span
                    >
                  </label>
                  <div
                    class="m--font-danger"
                    v-show="errors.has('formInfo.fecha_contratacion')"
                  >
                    <p class="error-style">
                      {{ $t('message.login_first_login_required_field') }}
                    </p>
                  </div>
                  <div class="m--font-danger" v-show="dateRequiredLicense">
                    <p class="warning-style">
                      {{ $t('message.userActive.requiredDate') }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-12 input-label-container">
                <div class="col-6 group-inputs-label">
                  <input
                    data-vs-input="form-info-file"
                    @keypress="editInformation('isEditingInfo')"
                    @keyup.delete="editInformation('isEditingInfo')"
                    class="input_styles"
                    :class="[
                      employeeState !== 3 ? 'groupInputLabel__input--borderBottom' : '',
                    ]"
                    type="text"
                    id="formInfo.numero_legajo"
                    maxlength="14"
                    v-validate="requiredLegajo ? 'required' : ''"
                    v-model="formInfo.numero_legajo"
                    name="formInfo.numero_legajo"
                    :required="docketTexting"
                    :disabled="employeeState == 3"
                  />
                  <div v-show="employeeState !== 3" class="edit--element">
                    <zt-icon name="pen" />
                  </div>
                  <span class="highlight"></span>
                  <span class="bar"></span>
                  <label class="label_styles">
                    {{ $t('message.userActive.numero_legajo') }}
                    <span
                      v-if="formInfoRequires.numero_legajo.required"
                      class="required_style"
                      >*</span
                    >
                  </label>
                  <div
                    class="m--font-danger"
                    v-show="errors.has('formInfo.numero_legajo')"
                  >
                    <p class="error-style">
                      {{ $t('message.login_first_login_required_field') }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="col-xl-12 col-lg-12 col-md-12">
      <div id="alertError" ref="alertPosition"></div>
      <div class="card card-style">
        <form action @submit.prevent="saveEditPosition" id="formPosition">
          <div class="card-body">
            <div>
              <div class="title_edit_container">
                <div class="subtitle_useram">
                  {{ $t('message.userActive.title_position_ubication') }}
                </div>
                <div v-if="isEditingPosition" class="m-portlet__head-caption">
                  <button
                    data-vs-button="form-info-position-cancel"
                    @click="cancelEditInformation('isEditingPosition')"
                    class="btn btn-secondary mr-4"
                  >
                    {{ $t('message.ob_submit_swal_reject') }}
                  </button>
                  <button
                    data-vs-button="form-info-save-position"
                    type="submit"
                    v-if="!loadingSectionLocation"
                    class="btn btn-primary"
                  >
                    {{ $t('message.ei_personal_info_save_changes') }}
                  </button>
                  <button
                    data-vs-button="form-info-saver-loading"
                    v-if="loadingSectionLocation"
                    class="btn btn-primary"
                  >
                    <div class="m-loader m-loader--light"></div>
                  </button>
                </div>
              </div>
              <hr />
            </div>
            <div class="row mt-2">
              <div class="col-12 input-label-container">
                <div class="col-6 select-editable pl-4 pr-5">
                  <label class="ml-2 typo__label font-weight-normal">{{
                    $t('message.search_text_4')
                  }}</label>
                  <multiselect
                    data-vs-select="form-info-select-postion"
                    class="multiselect-edit"
                    :disabled="employeeState == 3"
                    @input="editInformation('isEditingPosition')"
                    v-model="sectionSelected"
                    :options="sectionCompany"
                    :searchable="true"
                    :close-on-select="true"
                    :taggable="true"
                    @tag="addTagSector"
                    :tag-placeholder="$t('message.userActive.select_tag_sector')"
                    :placeholder="$t('message.userActive.select_section')"
                    :show-labels="false"
                  >
                    <template slot="noResult"
                      ><span class="multiselect__single">{{
                        $t('message.userActive.error_sector_not_found')
                      }}</span></template
                    >
                  </multiselect>
                </div>
                <div class="col-6 select-editable pl-4 pr-5">
                  <label class="ml-2 typo__label font-weight-normal">{{
                    $t('message.search_text_5')
                  }}</label>
                  <multiselect
                    data-vs-select="form-info-select-location"
                    :disabled="employeeState == 3"
                    @input="editInformation('isEditingPosition')"
                    v-model="locationSelected"
                    :options="locationCompany"
                    :searchable="true"
                    :close-on-select="true"
                    :taggable="true"
                    @tag="addTagLocation"
                    :tag-placeholder="$t('message.userActive.select_tag_location')"
                    :show-labels="false"
                    :placeholder="$t('message.userActive.select_section')"
                  >
                    <template slot="noResult"
                      ><span class="multiselect__single">{{
                        $t('message.userActive.error_locacion_not_found')
                      }}</span></template
                    >''
                  </multiselect>
                </div>
              </div>
              <div class="col-12 input-label-container">
                <div class="col-6 select-editable pl-4 pr-5 pt-2">
                  <label class="ml-2 typo__label font-weight-normal">{{
                    $t('message.userActive.position_position_ubication')
                  }}</label>
                  <multiselect
                    data-vs-select="form-info-position-user"
                    :disabled="employeeState == 3"
                    @input="editInformation('isEditingPosition')"
                    v-model="cargo"
                    name="cargo"
                    :options="positionCompany"
                    :searchable="true"
                    :close-on-select="true"
                    :taggable="true"
                    @tag="addTagPosition"
                    :tag-placeholder="$t('message.userActive.select_tag_position')"
                    :show-labels="false"
                    :placeholder="$t('message.userActive.select_position')"
                  >
                    <template slot="noResult"
                      ><span class="multiselect__single">{{
                        $t('message.userActive.error_position_not_found')
                      }}</span></template
                    >
                    <template slot="noOptions"
                      ><span class="multiselect__single">{{
                        $t('message.actions.empty_list')
                      }}</span></template
                    >
                  </multiselect>
                </div>
                <div class="col-6 select-editable pl-4 pr-5 pt-2">
                  <label class="ml-2 typo__label font-weight-normal">{{
                    $t('message.userActive.report_to_position_ubication')
                  }}</label>
                  <multiselect
                    data-vs-select="form-info-report-to"
                    :disabled="employeeState == 3"
                    @search-change="debounceSearchEmployees"
                    @input="editInformation('isEditingPosition')"
                    v-model="reporta_a"
                    :options="data_list"
                    :searchable="true"
                    label="name"
                    id="reporta_a"
                    :internal-search="false"
                    :clear-on-select="false"
                    :close-on-select="true"
                    :loading="isLoading"
                    :preserve-search="true"
                    :tag-placeholder="$t('message.form_select')"
                    :show-labels="false"
                    :placeholder="$t('message.userActive.search_combo_reporta_a')"
                  >
                    <template slot="noResult"
                      ><span class="multiselect__single">{{
                        $t('message.actions.not_founded')
                      }}</span></template
                    >
                    <template slot="noOptions"
                      ><span class="multiselect__single">{{
                        $t('message.actions.empty_list')
                      }}</span></template
                    >
                    <template slot="maxElements"
                      ><span class="multiselect__single">{{
                        $t('message.actions.max_elements')
                      }}</span></template
                    >
                  </multiselect>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <zt-modal
      class="rounded font-normal"
      :title="$t('message.userActive.warningTitle')"
      @close="closeDialog"
      max-width="600px"
      :active="cuilModal"
      :z-index="1001"
    >
      <template>
        <div class="flex items-center px-10 py-10">
          <div class="flex flex-none items-center w-24 h-24 justify-center mr-16">
            <zt-icon
              name="exclamation-circle-outline"
              class="text-zt-warning"
              :style="{ fontSize: '6rem' }"
            />
          </div>
          <div>
            <span class="w-full text-zt-xl text-zt-dark-500 font-normal">
              {{ $t('message.userActive.warningQuestion') }}
            </span>
            <p
              class="mb-4 mt-4 text-zt-dark-400 text-base"
              v-html="
              $sanitize($t('message.userActive.modalCuilMessage', {
                  nombre: this.dataInfo.nombre + ' ' + this.dataInfo.apellido,
                  viejoCuil: this.dataInfo.cuil,
                  nuevoCuil: this.formInfo.cuil,
                  documentCounter: this.documentCounter,
                }))
              "
            ></p>
            <p v-if="duplicateIdNumber" class="m--font-danger text-sm">
              {{ $t('message.userActive.duplicatedCuil') }}
            </p>
          </div>
        </div>
      </template>
      <template #modal-footer>
        <div class="zt-modal-footer rounded-b flex justify-end items-center p-4">
          <button
            class="font-medium btn--outlined text-zt-dark-400 focus:outlined-none pr-4"
            @click="closeDialog"
            data-vs-button="closeModal"
          >
            {{ $t('message.userActive.warningCancel') }}
          </button>
          <zt-button
            class="button-go-out"
            @click="editCuil()"
            data-vs-button="confirmModal"
          >
            {{ $t('message.userActive.warningSave') }}
          </zt-button>
        </div>
      </template>
    </zt-modal>
  </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker'
import { es } from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
import Alert from '@/components/generics/Alert.vue'
import Users from '@/apiClient/User'
import UserManagement from '@/apiClient/UserManagement'
import Multiselect from 'vue-multiselect'
import Search from '@/apiClient/Search'
import Vue from 'vue'
import { Validator } from 'vee-validate'
import { debounce } from 'lodash'

export default {
  name: 'UserPersonalInformation',
  components: {
    Datepicker,
    Alert,
    Multiselect,
  },
  props: {
    employeeState: 0,
    country: '',
    emailChange: '',
  },
  data() {
    return {
      es: es,
      dataInfo: {
        cuil: '',
        fecha: '',
        mail: '',
        nombre: '',
        apellido: '',
      },
      formInfo: {
        usuario: '',
        mail: '',
        nombre: '',
        apellido: '',
        dni: '',
        cuil: '',
        fecha_nacimiento: '',
        fecha_contratacion: '',
        numero_legajo: '',
        fecha_nacimiento_format: '',
        fecha_contratacion_format: '',
      },
      formInfoRequires: {
        usuario: {},
        mail: {},
        nombre: {},
        apellido: {},
        dni: {},
        cuil: {},
        fecha_nacimiento: {},
        fecha_contratacion: {},
        numero_legajo: {},
      },
      hasOnboarding: true,
      isEditingInfo: false,
      isEditingPosition: false,
      emailTexting: false,
      docketTexting: false,
      startDateTexting: false,
      bornDateTexting: false,
      nameTexting: false,
      lastnameTexting: false,
      cuilTexting: false,
      docTexting: false,
      userTexting: false,
      requiredLegajo: false,
      sectionSelected: [],
      sectionCompany: [],
      locationCompany: [],
      locationSelected: [],
      positionCompany: [],
      cargo: [],
      reporta_a: [],
      alertWarningShow: false,
      alertWarningShowCuil: false,
      loadingInfo: false,
      isLoading: false,
      loadingSectionLocation: false,
      page: 1,
      data_list: [],
      paramsPositionReport: '',
      bufferFree: true,
      dateRequiredLicense: false,
      cuilModal: false,
      documentCounter: 0,
      cuilWarningMessage: '',
      alerts: {},
      duplicateIdNumber: false,
      debounceSearchEmployees: '',
    }
  },
  created() {
    this.ob = new Search()
    this.userClient = new Users()
    this.userClientNew = new UserManagement()
    this.getUserInformation(this.$route.params.id)
    this.getCompanySectionLocation()
    this.verifyDate()
    this.debounceSearchEmployees = debounce((value) => this.searchEmployees(value), 500)
    Validator.extend('no_hyphen', {
      validate: (value) => {
        return !value.includes('-')
      },
      message: this.$t(`message.employeePanel.fieldValidation`),
    })
  },
  watch: {
    'formInfo.mail': function (val) {
      if (this.formInfo.mail != '') this.emailTexting = true
      else this.emailTexting = false
    },
    cargo: function (val) {
      if (this.cargo != '') this.cargoTexting = true
      else this.cargoTexting = false
    },
    'formInfo.numero_legajo': function (val) {
      if (this.formInfo.numero_legajo != '') this.docketTexting = true
      else this.docketTexting = false
    },
    'formInfo.fecha_contratacion': function (val) {
      if (this.formInfo.fecha_contratacion != '') this.startDateTexting = true
      else this.startDateTexting = false
    },
    'formInfo.fecha_nacimiento': function (val) {
      if (this.formInfo.fecha_nacimiento != '') this.bornDateTexting = true
      else this.bornDateTexting = false
    },
    'formInfo.usuario': function (val) {
      if (this.formInfo.usuario != '') {
        this.userTexting = true
      } else {
        this.userTexting = false
        this.alertWarningShow = false
      }
    },
    'formInfo.nombre': function (val) {
      if (this.formInfo.nombre != '') this.nameTexting = true
      else this.nameTexting = false
    },
    'formInfo.apellido': function (val) {
      if (this.formInfo.apellido != '') this.lastnameTexting = true
      else this.lastnameTexting = false
    },
    'formInfo.cuil': function (val) {
      if (this.formInfo.cuil != '') {
        this.cuilTexting = true
        this.isValidCuilCheck()
      } else this.cuilTexting = false
    },
    'formInfo.dni': function (val) {
      if (this.formInfo.dni != '') this.docTexting = true
      else this.docTexting = false
    },
    emailChange: function (val) {
      this.formInfo.mail = val
      this.getUserInformation(this.$route.params.id)
      this.emailChange = ''
    },
  },
  methods: {
    closeDialog() {
      this.cuilModal = false
    },
    verifyDate() {
      this.dateRequiredLicense = this.$store.getters.getActivateDate
    },
    buildSearch(cuil) {
      let qrySearchInit =
        '{"where":[{"fields":[{"operator":"in","alias":"cuil","value":["' +
        cuil +
        '"]},{"operator":"eq","alias":"estado_empresa","value":1}]}]}'
      this.isLoading = true
      this.paramsPositionReport = this.buildFilterForReport(cuil)
      this.ob
        .SearchEmployeesToReport(this.paramsPositionReport)
        .then((res) => {
          if (res.status === 200) {
            this.reporta_a = {
              name: '',
              cuil: '',
            }
            this.isLoading = false
            if (res.data && res.data[0]) {
              this.reporta_a.cuil = res.data[0].cuil
              this.reporta_a.name = res.data[0].nombre + ' ' + res.data[0].apellido
            }
          }
        })
        .catch((error) => {
          this.isLoading = false
          console.log(error)
        })
    },
    searchReport_to() {
      this.bufferFree = false
      this.isLoading = true
      this.ob
        .SearchEmployeesToReport(this.paramsPositionReport)
        .then((res) => {
          if (res.status === 200) {
            this.isLoading = false
            let auxData = res.data
            auxData.forEach((element) => {
              let reporter = {
                name: '',
                cuil: '',
              }
              reporter.name = element.nombre + ' ' + element.apellido
              reporter.cuil = element.cuil
              this.data_list.push(reporter)
              this.bufferFree = true
            })
          }
        })
        .catch((error) => {
          console.log(error)
          this.isLoading = false
          this.data_list = []
          this.bufferFree = true
        })
    },
    getUserInformation(id) {
      this.userClient
        .getinfoEmployee(id)
        .then((res) => {
          if (res.status === 200) {
            let response = res.data
            this.fillInfo(response)
          }
        })
        .catch((error) => {
          if (error.response.status === 404) {
            this.$router.push('/404H/')
          }
        })
    },
    fillInfo(response) {
      if (response.usuario !== null) this.formInfo.usuario = response.usuario
      if (response.mail !== null) this.formInfo.mail = response.mail
      if (response.nombre !== null) this.formInfo.nombre = response.nombre
      if (response.apellido !== null) this.formInfo.apellido = response.apellido
      if (response.dni !== null) this.formInfo.dni = response.dni
      if (response.cuil !== null) {
        this.formInfo.cuil = response.cuil
        this.dataInfo.cuil = response.cuil
      }
      if (response.fecha_nacimiento !== '' && response.fecha_nacimiento !== null)
        this.formInfo.fecha_nacimiento = moment(
          response.fecha_nacimiento,
          'DD/MM/YYYY'
        ).format('llll')

      if (response.fecha_contratacion !== '' && response.fecha_contratacion !== null) {
        this.formInfo.fecha_contratacion = moment(
          response.fecha_contratacion,
          'DD/MM/YYYY'
        ).format('llll')
      }
      if (response.numero_legajo !== null)
        this.formInfo.numero_legajo = response.numero_legajo
      if (response.sector !== null) this.sectionSelected = response.sector
      if (response.locacion !== null) this.locationSelected = response.locacion
      if (response.cargo !== null) this.cargo = response.cargo
      if (response.reporta !== null) {
        let report = response.reporta
        this.buildSearch(report)
      }
      let userList = {
        ...this.formInfo,
        sector: this.sectionSelected,
        locacion: this.locationSelected,
      }
      this.$store.dispatch('setUserList', userList)
      this.dataInfo.mail = this.formInfo.mail
      this.dataInfo.nombre = this.formInfo.nombre
      this.dataInfo.apellido = this.formInfo.apellido
      this.emitToParent(this.dataInfo)
      this.getRules(this.$route.params.id)
    },

    getRules(id) {
      this.userClientNew
        .getRules(id)
        .then((res) => {
          if (res.status === 200) {
            this.formInfoRequires = res.data
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    errorMessage(msg, type, title, duration, id) {
      if (this.alerts[id]) {
        this.alerts[id].$destroy()
        this.alerts[id].$el.parentNode.removeChild(this.alerts[id].$el)
      }
      const ComponentClass = Vue.extend(Alert)
      this.alerts[id] = new ComponentClass({
        propsData: { role: type, title: title, message: msg, duration: duration },
      }).$mount()
      this.$refs.alert.appendChild(this.alerts[id].$el)
    },
    saveEditInformation() {
      this.$validator.validateAll().then((valid) => {
        this.loadingInfo = true
        if (valid) {
          if (
            this.formInfo.fecha_contratacion === 'Invalid date' ||
            this.formInfo.fecha_contratacion === ''
          ) {
            this.formInfo.fecha_contratacion = ''
          } else {
            this.formInfo.fecha_contratacion_format = moment(
              this.formInfo.fecha_contratacion
            ).format('DD/MM/YYYY')
          }

          if (
            this.formInfo.fecha_nacimiento === 'Invalid date' ||
            this.formInfo.fecha_nacimiento === ''
          ) {
            this.formInfo.fecha_nacimiento = ''
          } else {
            this.formInfo.fecha_nacimiento_format = moment(
              this.formInfo.fecha_nacimiento
            ).format('DD/MM/YYYY')
          }

          if (this.country != 'AR' && this.country != 'LA') {
            this.formInfo.dni = this.formInfo.cuil
          }
          if (this.formInfo.cuil == this.dataInfo.cuil) {
            this.$store.dispatch('setUserList', this.formInfo)
            this.userClientNew
              .modifyUser(this.$route.params.id, this.formInfo)
              .then((res) => {
                console.log(res.status)
                if (res.status === 200) {
                  this.loadingInfo = false
                  swal({
                    type: 'success',
                    title: `${this.$t('message.employee_edit_success')}`,
                    showConfirmButton: true,
                    confirmButtonText: `${this.$t(
                      'message.billboard_form_post_button_confirm'
                    )}`,
                  }).then(() => {
                    this.getUserInformation(this.$route.params.id)
                    this.$store.dispatch('setActivateDate', false)
                    this.dateRequiredLicense = false
                    this.alertWarningShow = false
                    this.alertWarningShowCuil = false
                    this.isEditingInfo = false
                  })
                }
              })
              .catch((error) => {
                this.loadingInfo = false
                if (error.response.status == 400) {
                  let errors = error.response.data.codes
                  errors.map((fullerror) => {
                    this.showErrors(fullerror.code)
                  })
                }
              })
          } else {
            this.userClientNew
              .getDocumentsCounts(this.$route.params.id)
              .then((res) => {
                this.documentCounter = res.data.data.quantity
                this.cuilModal = true
                this.duplicateIdNumber = false
                this.loadingInfo = false
                this.alertWarningShowCuil = false
              })
              .catch((error) => {
                this.loadingInfo = false
                if (error.response.status == 400) {
                  this.loadingInfo = false
                  let errors = error.response.data.codes
                  errors.map((fullerror) => {
                    this.showErrors(fullerror.code)
                  })
                }
              })
          }
        } else {
          this.loadingInfo = false
          this.haveErrorInformation = true
          console.log('Hay errores')
        }
      })
    },
    showErrors(code) {
      let title = this.$t('message.actions.error')
      let message = this.$t('message.uploadImageComponent.errorLogs.' + code)
      this.errorMessage(message, 'danger', title, 'genericError')
    },
    cleanLocation() {
      this.locationSelected = []
    },
    cleanSection() {
      this.sectionSelected = []
    },
    cleanPosition() {
      this.cargo = []
    },
    addTagSector(newTag) {
      this.cleanSection()
      this.sectionSelected.push(newTag)
      this.editInformation('isEditingPosition')
    },
    addTagLocation(newTag) {
      this.cleanLocation()
      this.locationSelected.push(newTag)
      this.editInformation('isEditingPosition')
    },
    addTagPosition(newTag) {
      this.cleanPosition()
      this.cargo.push(newTag)
      this.editInformation('isEditingPosition')
    },
    saveEditPosition() {
      let sector = typeof this.sectionSelected
      let locacion = typeof this.locationSelected
      let report = typeof this.reporta_a
      let cargo = typeof this.cargo
      let sectorSend = ''
      let locacionSend = ''
      let cargoSend = ''
      let reportSend = ''
      this.loadingSectionLocation = true
      if (this.sectionSelected != null) {
        if (sector === 'object' && this.sectionSelected.length > 0) {
          sectorSend = this.sectionSelected[0]
        }
      }
      if (sector === 'string' && this.sectionSelected !== 'undefined') {
        sectorSend = this.sectionSelected
      }
      if (this.locationSelected != null) {
        if (locacion === 'object' && this.locationSelected.length > 0) {
          locacionSend = this.locationSelected[0]
        }
      }
      if (locacion === 'string' && this.locationSelected !== 'undefined') {
        locacionSend = this.locationSelected
      }
      if (this.cargo != null) {
        if (cargo === 'object' && this.cargo.length > 0) {
          cargoSend = this.cargo[0]
        }
      }
      if (cargo === 'string' && this.cargo !== 'undefined') {
        cargoSend = this.cargo
      }
      if (this.reporta_a != null) {
        if (report === 'object' && this.reporta_a.hasOwnProperty('cuil')) {
          reportSend = this.reporta_a.cuil
        } else {
          reportSend = ''
        }
      } else {
        reportSend = ''
      }
      let userNew = {
        sector: sectorSend.toUpperCase(),
        locacion: locacionSend.toUpperCase(),
      }
      this.$store.dispatch('setUserList', userNew)
      this.userClientNew
        .setSectionLocation(
          this.$route.params.id,
          sectorSend.toUpperCase(),
          locacionSend.toUpperCase()
        )
        .then((res) => {
          if (res.status === 200) {
            this.loadingSectionLocation = false
            this.userClientNew
              .setPositionReport(
                this.$route.params.id,
                cargoSend.toUpperCase(),
                reportSend
              )
              .then((res) => {
                if (res.status === 200) {
                  swal({
                    type: 'success',
                    title: `${this.$t('message.employee_edit_success')}`,
                    showConfirmButton: true,
                    confirmButtonText: `${this.$t(
                      'message.billboard_form_post_button_confirm'
                    )}`,
                  }).then(() => {
                    this.getUserInformation(this.$route.params.id)
                    this.getCompanySectionLocation()
                    this.isEditingPosition = false
                  })
                }
              })
              .catch((error) => {
                this.loadingSectionLocation = false
                if (error.response.status === 400) {
                  let type = 'danger'
                  let title = `${this.$t('message.actions.error')}`
                  let msg = `${this.$t('message.actions.error')}`
                  const ComponentClass = Vue.extend(Alert)
                  const instance = new ComponentClass({
                    propsData: {
                      role: type,
                      title: title,
                      message: msg,
                    },
                  }).$mount()
                  this.$refs.alertPosition.appendChild(instance.$el)
                }
              })
          }
        })
        .catch((error) => {
          this.loadingSectionLocation = false
          if (error.response.status === 400) {
            let type = 'danger'
            let title = `${this.$t('message.actions.error')}`
            let msg = `${this.$t('message.actions.error')}`
            const ComponentClass = Vue.extend(Alert)
            const instance = new ComponentClass({
              propsData: {
                role: type,
                title: title,
                message: msg,
              },
            }).$mount()
            this.$refs.alertPosition.appendChild(instance.$el)
          }
        })
    },
    cancelEditInformation(event) {
      this.errors.clear()
      switch (event) {
        case 'isEditingInfo':
          {
            this.alertWarningShow = false
            this.alertWarningShowCuil = false
            this.isEditingInfo = false
            this.getUserInformation(this.$route.params.id)
            this.formInfo.fecha_contratacion = moment(
              response.fecha_contratacion,
              'DD/MM/YYYY'
            ).format('llll')
            this.dataInfo.cuil = this.formInfo.cuil
            this.emitToParent(this.dataInfo)
          }
          break
        case 'isEditingPosition':
          {
            this.alertWarningShow = false
            this.isEditingPosition = false
            this.getUserInformation(this.$route.params.id)
          }
          break
        default:
          console.log('bad request')
      }
    },
    editInformation(event, inputName) {
      if (inputName === 'usuario') {
        if (!this.alertWarningShow) {
          this.alertWarningShow = true
        }
      }
      if (inputName === 'cuil') {
        if (!this.alertWarningShowCuil) {
          this.getCuilWarningMessage()
          this.alertWarningShowCuil = true
        }
      }
      switch (event) {
        case 'isEditingInfo':
          this.isEditingInfo = true
          break
        case 'isEditingPosition':
          {
            this.isEditingPosition = true
          }
          break
        default:
          console.log('bad request')
      }
    },
    getCompanySectionLocation() {
      this.userClient
        .listSector()
        .then((res) => {
          if (res.status === 200) {
            this.sectionCompany = res.data.results.data
            this.userClient
              .listLocacion()
              .then((res) => {
                if (res.status === 200) {
                  this.locationCompany = res.data.results.data
                  this.userClient
                    .listPosition()
                    .then((res) => {
                      if (res.status === 200 && res.data && res.data.results && res.data.results.data && res.data.results.data[0]) {
                        this.positionCompany = res.data.results.data[0]
                      }
                    })
                    .catch((error) => {
                      console.log(error)
                    })
                }
              })
              .catch((error) => {
                console.log(error)
              })
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    emitToParent(event) {
      this.$emit('childToParent', event)
    },
    buildFilter(value) {
      var params = new URLSearchParams()
      if (value.length !== 0) {
        params.append('principal', value)
      }
      params.append('estado', 1)
      return params
    },
    buildFilterForReport(value) {
      var params = new URLSearchParams()
      if (value.length !== 0) {
        params.append('search', value)
      }
      return params
    },
    searchEmployees(value) {
      this.data_list = []
      if (value.length > 2 && this.bufferFree) {
        this.editInformation('isEditingPosition')
        this.paramsPositionReport = this.buildFilterForReport(value)
        this.searchReport_to()
      }
    },
    getCuilWarningMessage() {
      if (!this.cuilWarningMessage) {
        this.userClientNew.getDocumentsCounts(this.$route.params.id).then((res) => {
          this.documentCounter = res.data.data.quantity
          this.cuilWarningMessage = this.$t('message.userActive.cuilWarningMessage', {
            input: this.documentCounter,
          })
          this.errorMessage(
            this.cuilWarningMessage,
            'warning',
            this.$t('message.employeePanel.importantTitle'),
            20000,
            'cuilWarning'
          )
        })
      } else {
        this.errorMessage(
          this.cuilWarningMessage,
          'warning',
          this.$t('message.employeePanel.importantTitle'),
          10000,
          'cuilWarning'
        )
      }
    },
    isValidCuilCheck() {
      const cuit = this.formInfo.cuil
      const invalidCuil = cuit.includes('-')
      if (invalidCuil) {
        this.errorMessage(
          this.$t('message.employeePanel.noValidCuil'),
          'danger',
          this.$t('message.employeePanel.importantTitle'),
          15000,
          'cuilHyphen'
        )
      }
    },
    editCuil() {
      const params = {
        personalIdNumber: this.formInfo.cuil,
      }
      this.userClientNew
        .updateUserManagement(this.$route.params.id, params)
        .then((res) => {
          if (res.status === 200) {
            this.dataInfo.cuil = `${this.formInfo.cuil}`
            this.closeDialog()
            this.saveEditInformation()
          }
        })
        .catch((error) => {
          if (
            error.response && error.response.data && error.response.data.codes && error.response.data.codes[0] &&
            error.response.data.codes[0].code == 'USER_PERSONAL_ID_NUMBER_ALREADY_EXISTS'
          )
            this.duplicateIdNumber = true
        })
    },
  },
}
</script>
<style scoped lang="scss">
@import './public/assets/scss/components/_usuarioam.scss';
.input-label-container {
  display: contents !important;
}
.offset-15 {
  margin: 0 -15px;
}
.zt-modal-footer {
  background-color: gainsboro;
}
</style>
